import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [restaurant, setRestaurant] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('nofee_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchMe();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchMe = async () => {
    try {
      const res = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(res.data.user);
      setRestaurant(res.data.restaurant);
    } catch {
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem('nofee_token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    setRestaurant(res.data.restaurant);
    return res.data;
  };

  // iter148 — Passwordless (magic-link) sign-in helper. The
  // /auth/magic-link/verify endpoint only returns {token, user} so we
  // rehydrate `restaurant` via /auth/me after storing the JWT.
  const loginWithToken = async (jwt) => {
    localStorage.setItem('nofee_token', jwt);
    setToken(jwt);
    const res = await axios.get(`${API}/auth/me`, {
      headers: { Authorization: `Bearer ${jwt}` },
    });
    setUser(res.data.user);
    setRestaurant(res.data.restaurant);
    return res.data;
  };

  const register = async (data) => {
    const res = await axios.post(`${API}/auth/register`, data);
    localStorage.setItem('nofee_token', res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    setRestaurant(res.data.restaurant);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('nofee_token');
    setToken(null);
    setUser(null);
    setRestaurant(null);
  };

  const api = axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  return (
    <AuthContext.Provider value={{ user, restaurant, token, loading, login, loginWithToken, register, logout, api, fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
